<template>
  <div class="con6">
    <div class="container">
      <p class="text-title">
        놀라긴 아직 일러요!<br />AI튜터 Plus의<br class="br-m" />
        the 드림 학습!
      </p>
      <ul class="content">
        <li>
          <img
            src="@/assets/img/aitutorplus/con6/icon0.png"
            alt=""
            class="icon"
          />
          <p>학습현황&복습 안내</p>
          <p>
            <span>한 눈에 보이는 학습현황</span>과<br /><span
              >꼼꼼한 복습 안내</span
            >로 다시 한번 실력 UP!
          </p>
          <video
            muted
            autoplay
            playsinline
            loop
            src="@/assets/img/aitutorplus/con6/video1.mp4"
          ></video>
        </li>
        <li>
          <img
            src="@/assets/img/aitutorplus/con6/icon1.png"
            alt=""
            class="icon"
          />
          <p>나만의 표현집</p>
          <p>
            기억하고 싶은 표현이 있다면?<br /><span
              >북마킹을 통해 유용한 표현만 모아</span
            ><br class="br-m" />
            집중 훈련!
          </p>
          <video
            muted
            autoplay
            playsinline
            loop
            src="@/assets/img/aitutorplus/con6/video2.mp4"
          ></video>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
img {
  display: block;
  width: 100%;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
}

video {
  display: block;
  width: 100%;
  object-fit: cover;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;

  @media screen and (min-width: 1200px) {
    padding: 0;
  }
}

.br-m {
  @media screen and (min-width: 1200px) {
    display: none;
  }
}

.con6 {
  padding: 86px 0;
  background-color: #18181b;

  @media screen and (min-width: 1200px) {
    padding: 174px 0;
  }

  .text-title {
    font-size: 30px;
    font-weight: 700;
    color: #fff;
    text-align: center;
    margin-bottom: 46px;

    @media screen and (min-width: 1200px) {
      font-size: 52px;
      margin-bottom: 82px;
    }
  }

  .content {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 54px;
    max-width: 400px;
    margin: 0 auto;

    @media screen and (min-width: 1200px) {
      grid-template-columns: repeat(2, 1fr);
      gap: 36px;
      max-width: 100%;
      height: 730px;
    }

    li {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      padding-top: 28px;
      border-radius: 26px;
      overflow: hidden;
      width: 320px;
      height: 536px;
      margin: 0 auto;

      @media screen and (min-width: 1200px) {
        width: 100%;
        height: auto;
      }

      &:nth-of-type(1) {
        height: 512px;
        background-color: #f3f4f6;

        @media screen and (min-width: 1200px) {
          height: auto;
        }
      }

      &:nth-of-type(2) {
        background-color: #8b5cf6;
      }

      video {
        position: absolute;
        left: 0;
        bottom: 0;
        height: 440px;
        margin: 0 auto;

        @media screen and (min-width: 1200px) {
          width: 100%;
          height: auto;
        }
      }

      @media screen and (min-width: 1200px) {
        padding-top: 48px;
      }

      &:nth-of-type(1) {
        p {
          z-index: 1;

          &:nth-of-type(1) {
            color: #8b5cf6;
          }

          &:nth-of-type(2) {
            color: #374151;
          }
        }
      }

      &:nth-of-type(2) {
        p {
          z-index: 1;

          &:nth-of-type(1) {
            color: #fff;
          }

          &:nth-of-type(2) {
            color: #f3f4f6;
          }
        }
      }

      .icon {
        width: 52px;
        margin-bottom: 14px;
        z-index: 1;
      }

      p {
        &:nth-of-type(1) {
          font-size: 26px;
          font-weight: 700;
          margin-bottom: 12px;
        }

        &:nth-of-type(2) {
          font-size: 18px;
          text-align: center;
          line-height: 27px;

          span {
            font-weight: 700;
          }
        }
      }

      .img {
        @media screen and (min-width: 1200px) {
          width: 482px;
          margin: 0 auto;
        }
      }
    }
  }
}
</style>
